import { Pipe, PipeTransform } from '@angular/core';
import { AccountItem } from './sb-account-list.component';

@Pipe({
    name: 'accountIdConcat',
    standalone: true
})
export class AccountIdConcatPipe implements PipeTransform {
    transform(accounts: Array<AccountItem | any>, key?: string): string {
        return accounts.map((account) => (key ? account[key] : account)).join(',');
    }
}
